module.exports = __webpack_public_path__ + "img/collect.79f72901.png";